import { baseSegment } from './routeAccess';

/** Link de checkout usado nos upsells de conteúdo bloqueado. */
export const SALES_LINK =
  'https://checkout.aprovatotal.com.br?seller=performance&source=plataforma&utm_source=plataforma&utm_medium=cpa-botao&utm_campaign=plataforma-conteudobloqueado&utm_content=assinar-o-plano';

/**
 * Upsell específico para o aluno cujo único produto é o curso de redação
 * (`destravando-a-redacao-em-30-dias`). Ao clicar em itens bloqueados ele é
 * levado para esta LP em vez do checkout genérico.
 */
export const REVISAO_ENEM_UPSELL_LINK =
  'https://aprovatotal.com.br/lp/upgrade-revisao-enem/';

export const SINGLE_COURSE_SLUG = 'destravando-a-redacao-em-30-dias';
export const SINGLE_COURSE_HREF = `/cursos/${SINGLE_COURSE_SLUG}`;

/** Remove barra final para comparar hrefs. */
const trimTrailingSlash = (path: string): string =>
  path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;

/**
 * true quando o único módulo de curso liberado é exatamente
 * `/cursos/destravando-a-redacao-em-30-dias` (sem `/cursos` amplo nem
 * outros cursos).
 */
export const hasOnlySingleCourseAccess = (
  platformModules?: string[] | null
): boolean => {
  if (!platformModules) return false;
  const courseModules = platformModules
    .map(trimTrailingSlash)
    .filter((m) => baseSegment(m) === '/cursos');
  return courseModules.length === 1 && courseModules[0] === SINGLE_COURSE_HREF;
};

/**
 * Link de upsell adequado ao acesso do aluno: quem só tem o curso de redação
 * é direcionado para a LP de revisão ENEM; os demais para o checkout padrão.
 */
export const getSalesLink = (platformModules?: string[] | null): string =>
  hasOnlySingleCourseAccess(platformModules)
    ? REVISAO_ENEM_UPSELL_LINK
    : SALES_LINK;
